import { ComponentStyleProps } from "../../../../lib/styles/props/component-style-props";
import { CMSearchResultCell } from "../../cell";
import {
  ComponentMultiStyleConfig,
  Tr,
  useMultiStyleConfig,
} from "@chakra-ui/react";
import React, { useMemo } from "react";
import { SearchResultRowContent } from "../types";
import { PositionProps, SystemStyleObject } from "@chakra-ui/styled-system";
import { hasValue } from "../../../../lib/util/common-util";
import { SearchResultTableOptions } from "../../table";

export type CMSearchResultRowProps = {
  content: SearchResultRowContent;
  options?: SearchResultTableOptions;

  cellStyles?: SystemStyleObject;

  /**
   * この値を指定すると、1列目がstickyになる。
   * この値は、その際のleftの値となる。
   * 注意: カテゴリありのヘッダ(2行に亘るヘッダ)を固定列とするのは未サポート。
   */
  stickyFirstColLeft?: PositionProps["left"];
  /**
   * この値を指定すると、2列目がstickyになる。
   * この値は、その際のleftの値となる。
   * 注意: カテゴリありのヘッダ(2行に亘るヘッダ)を固定列とするのは未サポート。
   */
  stickySecondColLeft?: PositionProps["left"];
} & ComponentStyleProps;

export const CMSearchResultRow = ({
  content,
  options,

  cellStyles,

  stickyFirstColLeft,
  stickySecondColLeft,

  ...rest
}: CMSearchResultRowProps) => {
  const styles = useMultiStyleConfig("CMSearchResultRowStyles");

  const mergedCellStyles = useMemo(() => {
    return {
      ...styles.cell,
      ...cellStyles,
    };
  }, [cellStyles, styles.cell]);

  return (
    <Tr alignItems="stretch" __css={styles.container} {...rest}>
      {content.cells.map((c, idx) => (
        <CMSearchResultCell
          key={idx}
          content={c}
          options={options}
          sx={mergedCellStyles}
          stickyLeft={
            idx === 0 && hasValue(stickyFirstColLeft)
              ? stickyFirstColLeft
              : idx === 1 && hasValue(stickySecondColLeft)
              ? stickySecondColLeft
              : undefined
          }
          stickyBorderLeftColor={
            idx === 0 && hasValue(stickyFirstColLeft)
              ? "gray.400"
              : idx === 1 && hasValue(stickySecondColLeft)
              ? "gray.200"
              : undefined
          }
        />
      ))}
    </Tr>
  );
};
export const CMSearchResultRowStyles: ComponentMultiStyleConfig = {
  parts: ["container", "cell"],
  baseStyle: {
    container: {},
    cell: {
      borderRightWidth: "1px",
      borderColor: "gray.200",
      _last: {
        borderRight: "0",
      },
    },
  },
};
